import LogoImg from "assets/images/rivet.jpg";
import { useSelector } from "react-redux";
import { AppState } from "store/reducers/Reducer";
import { formatBEDateToMediumDateString } from "utils";

interface ExportPdfProps {
  title: string;
  project: string;
  created_at: string;
  updated_at: string;
}

export const ExportPdfHeader: React.FC<ExportPdfProps> = ({
  title,
  project: _project,
  created_at: _created_at,
  updated_at: _updated_at,
}) => {
  const projectInfo = useSelector((state: AppState) => state.project);

  return (
    <div className="flex justify-around pt-[30rem] items-center pb-5 w-full">
      <div className="text-base">
        <div className="text-[48px] leading-10 capitalize text-left font-squada text-black">
          {title}
        </div>
        <div className="mt-2 capitalize">{projectInfo.name}</div>
        <div className="mt-2">
          Created: {formatBEDateToMediumDateString(projectInfo.created_at)}
        </div>
      </div>
      <div>
        <img src={LogoImg} width={"150px"} height={"150px"} />
      </div>
    </div>
  );
};
